'use client'

import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

// MUI Imports
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'

// Third-party Imports
import { Icon } from '@iconify/react'

// Component Imports
import CustomAvatar from '../../../../components/common/Template_Layouts/@core/components/mui/Avatar'

const PremiumModuleCards = ({ stats, onStatusClick, moduleName = 'CreditNote', customCards, activeFilters = ['All'], px = '24px' }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const data = customCards || [
        {
            title: stats?.total || 0,
            subtitle: `Total ${moduleName}s`,
            icon: 'ri:file-list-3-line',
            color: 'primary',
            key: 'All'
        },
        {
            title: stats?.open || 0,
            subtitle: 'Open',
            icon: 'ri:time-line',
            color: 'warning',
            key: 'Open'
        },
        {
            title: stats?.sentForApproval || 0,
            subtitle: 'Sent For Approval',
            icon: 'ri:send-plane-line',
            color: 'info',
            key: 'Sent For Approval'
        },
        {
            title: stats?.cancelled || 0,
            subtitle: 'Cancelled',
            icon: 'ri:close-circle-line',
            color: 'error',
            key: 'Cancelled'
        }
    ]

    return (
        <Card sx={{ boxShadow: 'none', border: 'none', borderRadius: 0, borderBottom: '1px solid #ebedf2', mb: 0 }}>
            <CardContent sx={{ py: 4, px: px }}>
                <Grid container spacing={6}>
                    {data.map((item, index) => (
                        <Grid 
                            item 
                            xs={12} 
                            sm={6} 
                            md={3} 
                            key={index}
                            onClick={() => onStatusClick && onStatusClick(item.key)}
                            sx={{ 
                                cursor: 'pointer', 
                                '&:hover': { opacity: 0.8 },
                                borderRight: { md: index < data.length - 1 ? '1px solid #ebedf2' : 'none' }
                            }}
                        >
                            <div className='flex justify-between items-center px-2'>
                                <div className='flex flex-col'>
                                    <Typography variant='h4' sx={{ fontWeight: 700, color: '#334155' }}>{item.title}</Typography>
                                    <Typography sx={{ color: '#64748b', fontSize: '14px', fontWeight: 500 }}>{item.subtitle}</Typography>
                                </div>
                                <CustomAvatar variant='rounded' size={42} skin='light' color={item.color}>
                                    <Icon icon={item.icon} fontSize={26} />
                                </CustomAvatar>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    )
}

export default PremiumModuleCards
